import { root } from './Box.css';

import { RecipeVariants } from '@/theme/utils/createRecipeObj';
import { createUseRecipeHook } from '@/theme/utils/createUseRecipeHook';

export const useBoxStyle = createUseRecipeHook(root);
export type BoxStyleProps = RecipeVariants<typeof root>;
